import apiSlice from "./apiSlice";
const keyClaimsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeyClaims: builder.mutation({
      query: (body) => ({
        url: `claims`,
        method: "POST",
        body,
      }),
    }),
    editKeyClaims: builder.mutation({
      query: ({ id, body }) => ({
        url: `/claims/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteKeyClaims: builder.mutation({
      query: (id, body) => ({
        url: `claims/${id}`,
        method: "DELETE",
        body,
      }),
    }),
    approveKeyClaims: builder.mutation({
      query: ({ id }) => ({
        url: `/claims/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectKeyClaims: builder.mutation({
      query: ({ id, body }) => ({
        url: `/claims/${id}/reject`,
        method: "POST",
        body,
      }),
    }),
    updateWorkflowClaims: builder.mutation({
      query: (body) => ({
        url: `/Claims/UpdateWorkFlow`,
        method: "POST",
        body,
      }),
    }),
    getClaims: builder.query({
      query: (req) => ({
        url: `Claims/${req}`,
      }),
    }),
  }),
});

export const {
  useAddKeyClaimsMutation,
  useEditKeyClaimsMutation,
  useDeleteKeyClaimsMutation,
  useApproveKeyClaimsMutation,
  useRejectKeyClaimsMutation,
  useUpdateWorkflowClaimsMutation,
  useGetClaimsQuery
} = keyClaimsSlice;
